import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=4aafdf41&"
import script from "./Tokens.vue?vue&type=script&lang=js&"
export * from "./Tokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports